import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { IconLegacyComponent, NotificationComponent } from '../../deprecated'
import { MarkdownDirective } from '../../directives'
import { NotificationFlashComponent } from './notification-flash.component'

/**
 * This module contains reusable notification components
 */
@NgModule({
  imports: [CommonModule, IconLegacyComponent, MarkdownDirective, NotificationComponent, NotificationFlashComponent],
  declarations: [],
  exports: [NotificationComponent, NotificationFlashComponent],
})
export class NotificationModule {}
